module.exports = __webpack_public_path__ + "media/images/favicons/safari-pinned-tab-c578472e494159db9a3860852b90acd8.svg";